import React from 'react';

const OAuthDivider = ({ text = "or" }) => {
    return (
        <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200 dark:border-strokedark"></div>
            </div>
            <div className="relative flex justify-center text-xs">
                <span className="bg-white dark:bg-boxdark px-3 text-gray-400 dark:text-bodydark2 uppercase tracking-wider">
                    {text}
                </span>
            </div>
        </div>
    );
};

export default OAuthDivider;
